import { ItemCache } from './schema/ItemCache';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { CacheItem } from './schema/CacheItem';
import { CacheDescriptor } from './schema/CacheDescriptor';

let stores: { [key: string]: ItemCache<any, any> } = {};

export function getStore<T extends CacheItem, U extends CacheDescriptor>(
    key: string
): ItemCache<T, U> {
    return stores[key];
}

export function createItemCacheStore<T extends CacheItem, U extends CacheDescriptor>(
    key: string
): ItemCache<T, U> {
    if (!stores[key]) {
        stores[key] = createStore<ItemCache<T, U>>(key, <ItemCache<T, U>>{
            key: key,
            items: new ObservableMap(),
            descriptors: new ObservableMap(),
            locks: new ObservableMap(),
        })();
    }
    return stores[key];
}
